import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

@Component({ template: '' })
export abstract class AbstractCrudCES<T> implements OnInit {
  form: FormGroup;
  config: IFieldConfig[];
  typeCes: TypeCesEnum;
  title = '--';
  data: T | any;

  constructor(public fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.createGroup();
  }

  public getFieldConfig(name: string): any {
    return this.config.find((c) => c.name === name);
  }

  public createGroup() {
    const group = this.fb.group({});
    this.controls.forEach((control) =>
      group.addControl(control.name, this.createControl(control))
    );

    return group;
  }

  public get controls() {
    return this.config
      .filter(({ type }) => type !== 'button')
      .map((control) => {
        if (this.typeCes === TypeCesEnum.SHOW) {
          control.disabled = true;
        } else {
          control.disabled = false;
        }

        return control;
      });
  }

  public createControl(config: IFieldConfig) {
    const { disabled, validation, value } = config;
    // Se o valor não estiver definido, usar null ao invés de undefined
    const controlValue = value !== undefined ? value : null;
    return this.fb.control({ disabled, value: controlValue }, validation);
  }

  setValue(field: string, value: any, emitEvent = true) {
    this.form.controls[field].setValue(value, {
      emitEvent,
    });
  }

  setDisabled(field: string, value = true) {
    if (value) this.form?.controls[field]?.disable();
    else this.form?.controls[field]?.enable();
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
